import { render } from "./TableOfContents.vue?vue&type=template&id=5532eff2&ts=true"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__